import { Disclosure } from '@headlessui/react';

import { CaretUpIcon } from '~components/icons';
import { CaretDownIcon } from '~components/icons/CaretDownIcon';
import { ShareVariationListItemPanelController } from '~modules/media-library/controller/ShareVariationListItemPanelController';
import { DownloadVariation } from '~modules/media-library/model/DownloadVariation';
import { ShareAction } from '~modules/media-library/view/ShareModal/ShareAction';

type Props = {
  downloadVariation: DownloadVariation;
  disabled: boolean;
  shareAction: ShareAction;
};

export function ShareVariationListItem({ downloadVariation, disabled, shareAction }: Props) {
  // early exit
  if (!downloadVariation) return null;

  return (
    <Disclosure>
      {({ open }) => (
        <>
          <Disclosure.Button
            className={`appearance-none flex w-full justify-between items-center border-none outline-none text-left rounded-md transition shadow-none hover:shadow-md cursor-pointer ${
              open ? 'bg-gray' : 'bg-white hover:bg-gray'
            }`}
            disabled={disabled}
          >
            <span className="flex flex-col p-2">
              <span className="font-sans font-bold text-base">{downloadVariation.title}</span>
              <span className="font-sans text-sm">{downloadVariation.shortDescription}</span>
            </span>
            <div className="w-8 h-8 p-1">{open ? <CaretUpIcon /> : <CaretDownIcon />}</div>
          </Disclosure.Button>
          <Disclosure.Panel className="px-4 py-2">
            <div className="flex justify-between items-center h-8 font-sans text-black ">
              <div className="text-base pr-2 truncate">{downloadVariation.fileName}</div>
              <ShareVariationListItemPanelController downloadVariation={downloadVariation} shareAction={shareAction} />
            </div>
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
}
